import Axios from "../../../utils/axios";

export const getSettings = (data) => {
    return (dispatch) => {
        Axios.get("/raffle-settings", dispatch, "GET_SETTINGS", data)
            .then((response) => {
                return response.response.data
            });
    };
};